// Mirrors config/documents.php on the backend (OL-140). The server enforces
// the list on every upload; this only filters the file pickers.
export const DOCUMENT_EXTENSIONS = [
  '.pdf', '.doc', '.docx', '.txt', '.rtf',
  '.xls', '.xlsx', '.csv', '.ppt', '.pptx',
  '.jpg', '.jpeg', '.png', '.gif', '.tiff', '.tif', '.heic', '.heif', '.webp', '.bmp',
  '.msg', '.eml',
  '.mp3', '.m4a', '.wav', '.mp4', '.mov', '.avi', '.wmv',
  '.zip', '.dcm',
];

/** For a plain <input type="file" accept="..."> */
export const DOCUMENT_ACCEPT_ATTRIBUTE = DOCUMENT_EXTENSIONS.join(',');

/**
 * For react-dropzone's `accept`. It matches a file on either the MIME type or
 * the extension, so one generic MIME key with every extension keeps the picker
 * open to everything on the list without maintaining a MIME map here.
 */
export const DOCUMENT_DROPZONE_ACCEPT = { 'application/octet-stream': DOCUMENT_EXTENSIONS };
